export class DateParser {
    static parse(date: Date) {
        const d = [date.getFullYear(), this.parseFix(date.getMonth() + 1), this.parseFix(date.getDate())];
        const t = [this.parseFix(date.getHours()), this.parseFix(date.getMinutes()), this.parseFix(date.getSeconds())];

        return d.join('-') + ' ' + t.join(':');

    }

    static parseFix(n: number) {
        let s = n.toString();
        if (n < 10) {
            s = '0' + n.toString();
        }
        return s;
    }
}